'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SALES_SIGNUP_FORM_ID: 'ec22dca9-7341-47d9-bccb-2cfbf327b7ef',
  CRM_SIGNUP_FORM_ID: '0bda4317-f16b-4eb6-941c-50aa08469d61',
  LEADIN_SIGNUP_FORM_ID: 'ccab02d7-d97b-4a27-928a-914bc7185ce4',
  SERVICE_SIGNUP_FORM_ID: 'b04a5aca-7fec-451d-b909-704a46881d96',
  ACADEMY_SIGNUP_FORM_IDS: {
    de: '8b1fc951-5557-45ab-b978-e67798be394f',
    en: 'fb10e372-c8af-41ba-987c-c841965fc2c8',
    es: 'e020aed9-340e-436a-bf37-a68fb0ca2a5b',
    pt: '8299c5c6-5ead-415f-869f-0110d554d0e7',
    'pt-br': '8299c5c6-5ead-415f-869f-0110d554d0e7',
    fr: '4b0ce9db-d933-4162-9a64-d068e8aba3ac'
  },
  FOR_STARTUPS_APPLICATION_FORM_ID: '66bc0886-7bfa-41f2-a6ba-95e2357a0c04',
  PARTNER_CLIENT_SIGNUP: 'df53618d-1d29-482c-a805-d6cae4adb441',
  SALES_PARTNER_SIGNUP: '33976cec-9524-47d0-8782-62653a95d515',
  DIRECTORY_USER_SIGNUP: '83753998-5503-4bea-bc6c-1e7eb2cd1bc6',
  TRIAL_SIGNUP_FORM_ID: '7527603b-641f-476f-898b-d1eeb020e8ea'
};
module.exports = exports['default'];